import { TableCell, TableRow } from "@mui/material";
import { getArrayIsNotEmpty } from "../../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AllActiveCarRequestTableRow = ({
    carRequest
}) => {

    const navigate = useNavigate();

    const GetImageComponent = () => {
        let imgSource = '';

        const requestHaveImages = getArrayIsNotEmpty(carRequest.PartRequestImages);

        if (requestHaveImages) {
            imgSource = carRequest.PartRequestImages[0].small_part_request_image_url;
        };

        const ImageComponent = (
            <div style={styles.imageContainer}>
                <img
                    src={imgSource}
                    style={styles.imageStyle}
                />
            </div>
        );

        return imgSource
            ? ImageComponent
            : <div />
    };


    const getCreatedAtBeforeString = () => {
        const now = moment();
        const createdAtMoment = moment(carRequest.createdAt);

        const diffInDays = now.diff(createdAtMoment, 'day');

        const caseOne = (diffInDays === 0);
        const caseTwo = (diffInDays === 1);
        const caseThree = (diffInDays === 2);
        const caseFour = (diffInDays > 2);

        let finalString = "";

        if (caseOne) {
            finalString = createdAtMoment.format("HH:mm");
        }

        else if (caseTwo) {
            finalString = "Pre 1 dan";
        }

        else if (caseThree) {
            finalString = "Pre 2 dana";
        }

        else if (caseFour) {
            finalString = createdAtMoment.format("DD.MM.YYYY - HH:mm")
        };


        if (!finalString) {
            throw new Error("Created at string was not parsed");
        };

        return finalString;
    };

    const handleOpenSingleRequestPage = (id) => {
        navigate(`/part-request/${id}`);
    };


    return (
        <TableRow
            onClick={() => handleOpenSingleRequestPage(carRequest.part_request_id)}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell>
                {GetImageComponent()}
            </TableCell>

            <TableCell>
                {carRequest.UserCar.title}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.title}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {getCreatedAtBeforeString()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.partOfferCount}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.description}
            </TableCell>

        </TableRow>
    )
};


export default AllActiveCarRequestTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)"
    }
};